(() => {
  if (window.sdusaOurProcessSliderInitialized) return;
  window.sdusaOurProcessSliderInitialized = true;

  function initSingleOurProcessSlider(slider) {
    if (!slider) return;
    if (typeof Swiper === "undefined") {
      window.addEventListener("load", () => initSingleOurProcessSlider(slider), { once: true });
      return;
    }

    const isMobile = window.matchMedia("(max-width: 767px)").matches;
    if (!isMobile) {
      if (slider.swiper) slider.swiper.destroy(true, true);
      return;
    }

    if (slider.swiper) slider.swiper.destroy(true, true);

    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 16,
      watchOverflow: true,
      observer: true,
      observeParents: true,
    });
  }

  function initOurProcessSliders() {
    const sliders = document.querySelectorAll(".sdusa-our-process__swiper");
    sliders.forEach(initSingleOurProcessSlider);
  }

  function setupOurProcessObserver() {
    const sliders = document.querySelectorAll(".sdusa-our-process__swiper");
    if (!sliders.length) return;

    if (!("IntersectionObserver" in window) || (window.Shopify && window.Shopify.designMode)) {
      initOurProcessSliders();
      return;
    }

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          obs.unobserve(entry.target);
          initSingleOurProcessSlider(entry.target);
        }
      });
    }, { rootMargin: "350px 0px" });

    sliders.forEach((s) => observer.observe(s));
  }

  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initOurProcessSliders, 150);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setupOurProcessObserver);
  } else {
    setupOurProcessObserver();
  }
  document.addEventListener("shopify:section:load", initOurProcessSliders);
  document.addEventListener("shopify:section:select", initOurProcessSliders);
})();
